var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.999,
    viewBox: "0 0 20 19.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{isolation:isolate;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0 -0.008)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M285.874,209.258h-7.917a.625.625,0,0,1,0-1.25h7.917a.625.625,0,0,1,0,1.25Zm0,0",
    transform: "translate(-266.499 -199.875)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M400.629,135.471a.625.625,0,0,1-.442-1.068l2.683-2.683-2.683-2.683a.625.625,0,0,1,.884-.884l3.125,3.125a.625.625,0,0,1,0,.884l-3.125,3.125A.62.62,0,0,1,400.629,135.471Zm0,0",
    transform: "translate(-384.379 -122.963)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.667,20.007a1.717,1.717,0,0,1-.517-.078L1.135,18.259A1.682,1.682,0,0,1,0,16.674v-15A1.668,1.668,0,0,1,1.667.008a1.719,1.719,0,0,1,.517.078L7.2,1.756A1.682,1.682,0,0,1,8.333,3.341v15A1.668,1.668,0,0,1,6.667,20.007Zm-5-18.749a.418.418,0,0,0-.417.417v15a.433.433,0,0,0,.289.4l4.991,1.663a.453.453,0,0,0,.136.018.418.418,0,0,0,.417-.417v-15a.433.433,0,0,0-.289-.4L1.8,1.276A.452.452,0,0,0,1.667,1.258Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M38.334,6.674a.625.625,0,0,1-.625-.625V2.3a1.043,1.043,0,0,0-1.042-1.042H27.293a.625.625,0,0,1,0-1.25h9.375A2.293,2.293,0,0,1,38.959,2.3v3.75A.625.625,0,0,1,38.334,6.674Zm0,0",
    transform: "translate(-25.626 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M185.29,284.006h-3.333a.625.625,0,0,1,0-1.25h3.333a1.043,1.043,0,0,0,1.042-1.042v-3.75a.625.625,0,1,1,1.25,0v3.75A2.293,2.293,0,0,1,185.29,284.006Zm0,0",
    transform: "translate(-174.249 -266.499)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.4a932381939cf49f575803648913e9a5.svg";
export { ForwardRef as ReactComponent };